import React, { useState, useRef, useEffect } from 'react';
import './App.css';

function App() {
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! I\'m your AI travel assistant. Tell me about your dream trip and I\'ll help you book flights, hotels, and transportation!'
    }
  ]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim() || isLoading) return;

    const userMessage = { role: 'user', content: input };
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setIsLoading(true);

    try {
      const response = await fetch('http://ishaaluxurytravel.com/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: input,
          conversation_history: messages
        }),
      });

      const data = await response.json();
      
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: data.response,
        bookings: data.bookings
      }]);
    } catch (error) {
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: 'Sorry, I encountered an error. Please try again.'
      }]);
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderBookingCard = (booking) => {
    if (booking.type === 'flight') {
      return (
        <div className="booking-card flight">
          <h4>✈️ Flight Booking</h4>
          <p><strong>From:</strong> {booking.from}</p>
          <p><strong>To:</strong> {booking.to}</p>
          <p><strong>Date:</strong> {booking.date}</p>
          <p><strong>Price:</strong> ${booking.price}</p>
          <button className="confirm-btn">Confirm Booking</button>
        </div>
      );
    } else if (booking.type === 'hotel') {
      return (
        <div className="booking-card hotel">
          <h4>🏨 Hotel Booking</h4>
          <p><strong>Hotel:</strong> {booking.name}</p>
          <p><strong>Location:</strong> {booking.location}</p>
          <p><strong>Check-in:</strong> {booking.checkin}</p>
          <p><strong>Check-out:</strong> {booking.checkout}</p>
          <p><strong>Price:</strong> ${booking.price}/night</p>
          <button className="confirm-btn">Confirm Booking</button>
        </div>
      );
    } else if (booking.type === 'cab') {
      return (
        <div className="booking-card cab">
          <h4>🚕 Cab Booking</h4>
          <p><strong>Pickup:</strong> {booking.pickup}</p>
          <p><strong>Destination:</strong> {booking.destination}</p>
          <p><strong>Date:</strong> {booking.date}</p>
          <p><strong>Price:</strong> ${booking.price}</p>
          <button className="confirm-btn">Confirm Booking</button>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="App">
      <div className="chat-container">
        <div className="chat-header">
          <h1>🌍 AI Travel Assistant</h1>
          <p>Your personal travel booking companion</p>
        </div>
        
        <div className="messages-container">
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.role}`}>
              <div className="message-content">
                {message.content}
                {message.bookings && message.bookings.length > 0 && (
                  <div className="bookings-container">
                    {message.bookings.map((booking, idx) => (
                      <div key={idx}>{renderBookingCard(booking)}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
          {isLoading && (
            <div className="message assistant">
              <div className="message-content loading">
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        <form className="input-container" onSubmit={handleSubmit}>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Describe your travel plans..."
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading || !input.trim()}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
}

export default App;
